export default __webpack_public_path__ + "static/kb_fr-0b71eafd07f754113d61029aeb8df346.jpg";